import { useCallback, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useAppSelector } from 'src/app/store';
import { useOrganizationSettingsConnectMerchantAccountCreateMutation } from 'src/common/external/bambi-api/bambiApi';
import { Button } from 'src/common/primitives/Button';
import { LoadingIndicator } from 'src/common/primitives/LoadingIndicator';
import { TilledLogo } from 'src/common/primitives/logos/TilledLogo';
import { show } from 'src/common/primitives/Toast/toast.slice';

import { launchApplicationPopup } from '../helpers/launchApplicationPopup';

export function StartTilledMerchantApplication() {
  const [createMerchantAccount] =
    useOrganizationSettingsConnectMerchantAccountCreateMutation();

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const nextToastId = useAppSelector((state) => state.toast.nextId);

  const handleCreateMerchantAccount = useCallback(async () => {
    if (loading) {
      return;
    }

    setLoading(true);
    try {
      const result = await createMerchantAccount({}).unwrap();
      dispatch(
        show({
          id: nextToastId,
          title: 'Merchant Application Created',
          description: 'The merchant application has successfully been created',
          type: 'success',
        })
      );

      if (!result.onboarding_application_url)
        throw new Error('Missing onboarding_application_url');

      // Launch tilled application flow
      launchApplicationPopup(result.onboarding_application_url);
    } catch (e) {
      dispatch(
        show({
          id: nextToastId,
          title: 'Failed to create Merchant Application',
          description:
            'We were unable to create the merchant application with our partner Tilled. Please try again, if this persists please contact Bambi support.',
          type: 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  }, [loading, dispatch, nextToastId, createMerchantAccount]);

  return (
    <>
      <div
        data-testid="start-tilled-merchant-application"
        className="flex flex-grow flex-row items-center gap-2"
      >
        <TilledLogo />
        <div>
          Create your merchant account with our payment processing partner
          Tilled.
        </div>
      </div>
      <div>
        <Button
          dataTestId="tilled-connect-button"
          onClick={handleCreateMerchantAccount}
        >
          {loading ? <LoadingIndicator /> : 'Connect'}
        </Button>
      </div>
    </>
  );
}
